import { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";

import { api_without_cancellation } from "../../api/api";

const EditModalProvider = ({ show, handleClose, injuryId, onSave, onDelete, providerAdding }) => {
  const [formData, setFormData] = useState({});
  const [injuryData, setInjuryData] = useState({});
  const [caseProviders, setCaseProviders] = useState([]);

  const fetchInjuryDetails = useCallback(async (injuryId) => {
    try {
      const response = await api_without_cancellation.get(`/api/injuries/${injuryId}/details/`);
      if (response.status !== 200) {
        const errorText = await response.text();
        throw new Error(`Server Error: ${errorText}`);
      }
      const data = await response.data;
      setInjuryData(data.injury_data);
      setCaseProviders(data.case_providers);
      initializeFormData(data.injury_data.injury_details);
    } catch (error) {
      console.error("Error fetching injury details:", error);
    }
  }, []);

  useEffect(() => {
    if (injuryId) {
      fetchInjuryDetails(injuryId);
    }
  }, [injuryId, fetchInjuryDetails]);

  const initializeFormData = (details) => {
    const initialData = {};
    details.forEach((detail) => {
      initialData[detail.provider?.id] = { linked: true, note: detail.note };
    });
    setFormData(initialData);
  };

  const handleChange = (providerId, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [providerId]: {
        ...prev[providerId],
        [field]: value,
      },
    }));
  };

  const handleSubmit = () => {
    const providers = Object.entries(formData)
      .filter(([, v]) => v.linked)
      .map(([providerId, v]) => ({
        provider_id: Number(providerId),
        note: v.note || "",
      }));
    onSave({ providers });
  };

  function mixColorWithWhite(hex, percentage) {
    const whitePercentage = (100 - percentage) / 100;

    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    r = Math.floor(r + (255 - r) * whitePercentage);
    g = Math.floor(g + (255 - g) * whitePercentage);
    b = Math.floor(b + (255 - b) * whitePercentage);

    return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="max-700 modal-dialog-centered"
      contentClassName="custom-modal-new-provider"
      size="lg"
    >
      <div style={{ minHeight: "200px" }}>
        <Modal.Header
          style={{ borderBottom: "0px" }}
          className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
        >
          <Modal.Title
            className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
            style={{ fontSize: "14px", fontWeight: "600" }}
          >
            {injuryData.body_part
              ? `${injuryData.body_part.name}: Link Medical Providers, Records and Notes`
              : "Add Notes and Link Medical Providers"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="p-0 "
          style={{
            minHeight: "200px",
            maxHeight: "600px",
            overflow: "scroll",
            scrollbarWidth: "none",
          }}
        >
          <div className="custom-tab">
            <table className="table table-borderless table-striped  injuires-table has-height-25">
              <thead>
                <tr className="tb-header">
                  <th
                    className="text-center"
                    style={{
                      background: "var(--primary-10)",
                      color: "var(--primary)",
                    }}
                  >
                    PROVIDER
                  </th>
                  <th
                    style={{
                      background: "var(--primary-10)",
                      color: "var(--primary)",
                    }}
                    className="text-center"
                  >
                    LINK
                  </th>
                  <th
                    style={{
                      background: "var(--primary-10)",
                      color: "var(--primary)",
                    }}
                    className="text-center"
                  >
                    NOTES
                  </th>
                </tr>
              </thead>
              <tbody>
                {caseProviders.map((provider) => {
                  const specialtyColor = provider.specialty.color;
                  const backgroundColor = mixColorWithWhite(specialtyColor, 10);
                  const backgroundColor2 = mixColorWithWhite(specialtyColor, 2);
                  return (
                    <tr
                      key={provider.id}
                      className={`hover has-speciality-color-${provider.specialty.id}`}
                    >
                      <td className="provider-field td-autosize p-r-5" style={{ backgroundColor }}>
                        <div className="d-flex height-25">
                          <div
                            className="d-flex align-items-center m-r-5 text-center justify-content-center font-weight-600 injury-color-white "
                            style={{
                              background: provider.specialty.color,
                              width: "25px",
                              height: "25px",
                              color: "white",
                              fontWeight: "600",
                            }}
                          >
                            {provider.specialty.name.charAt(0)}
                          </div>
                          <div
                            className="align-self-center m-r-5"
                            style={{
                              fontWeight: "600",
                              color: "black",
                            }}
                          >
                            {provider.location.added_by.providerprofile.office_name}
                          </div>
                        </div>
                      </td>
                      <td
                        className="td-autosize text-center"
                        style={{ backgroundColor: backgroundColor2 }}
                      >
                        <input
                          type="checkbox"
                          checked={formData[provider.id]?.linked || false}
                          onChange={(e) => handleChange(provider.id, "linked", e.target.checked)}
                          // style={{ marginLeft: "-0.25rem" }}
                          style={{
                            cursor: "pointer",
                          }}
                        />
                      </td>
                      <td style={{ backgroundColor2 }}>
                        <input
                          type="text"
                          placeholder="Add Note About Injured Body Part"
                          className="form-control height-25 p-0 p-l-5 rounded-0"
                          onFocus={(e) => {
                            e.target.placeholder = "";
                            e.target.style.color = "black";
                          }}
                          onBlur={(e) => {
                            e.target.placeholder = "Add Note About Injured Body Part";
                          }}
                          style={{ color: "var(--primary-25)" }}
                          value={formData[provider.id]?.note || ""}
                          onChange={(e) => handleChange(provider.id, "note", e.target.value)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Modal.Body>

        <Modal.Footer
          className="p-0 mt-0 padding-outside-btn-new-provider"
          style={{ borderTop: "none" }}
        >
          <Button
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            variant="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            variant="danger"
            onClick={() => onDelete()}
            disabled={providerAdding}
          >
            Delete
          </Button>
          <Button
            variant="success"
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            onClick={handleSubmit}
            disabled={providerAdding}
          >
            Save and Close
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default EditModalProvider;
